import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';
import type { TaskTreeNode } from '../types';

export function useTaskTree(taskId: string | null): ReturnType<typeof useQuery<TaskTreeNode>> {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TASK_KEYS.tree(orgId, taskId ?? ''),
    queryFn: ({ signal }) => tasksService.getTaskTree(taskId!, signal),
    enabled: !!orgId && !!taskId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
}
